/**
 * 我采购的密函列表地址
 */
export const SECRET_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/secret/list/purchase'
